<template>
    <div class="p-3">
        <div
            class="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3"
        >
            <div>
                <h3 class="mb-1">File Status Masuk</h3>
                <div class="text-muted">
                    Monitoring pengembalian berkas rekam medis.
                </div>
            </div>

            <button
                type="button"
                class="btn btn-danger"
                :disabled="loading"
                @click="printPdf"
            >
                <i class="fa fa-file-pdf-o me-1"></i>
                Print PDF
            </button>
        </div>

        <div class="card border-0 shadow-sm mb-3">
            <div class="card-header bg-white fw-semibold">
                <i class="fa fa-filter text-primary me-1"></i>
                Pencarian Data
            </div>

            <div class="card-body">
                <div class="row g-3">
                    <div class="col-12 col-md-6 col-xl-3">
                        <label class="form-label small fw-semibold text-muted">
                            No. Registrasi
                        </label>

                        <input
                            v-model="filter.Regno"
                            type="text"
                            class="form-control"
                            placeholder="No. Registrasi"
                            :disabled="loading"
                            @keyup.enter="applyFilter"
                        />
                    </div>

                    <div class="col-12 col-md-6 col-xl-3">
                        <label class="form-label small fw-semibold text-muted">
                            No. Rekam Medis
                        </label>

                        <input
                            v-model="filter.Medrec"
                            type="text"
                            class="form-control"
                            placeholder="No. RM"
                            :disabled="loading"
                            @keyup.enter="applyFilter"
                        />
                    </div>

                    <div class="col-12 col-md-6 col-xl-3">
                        <label class="form-label small fw-semibold text-muted">
                            Nama Pasien
                        </label>

                        <input
                            v-model="filter.Firstname"
                            type="text"
                            class="form-control"
                            placeholder="Nama pasien"
                            :disabled="loading"
                            @keyup.enter="applyFilter"
                        />
                    </div>

                    <div class="col-12 col-md-6 col-xl-3">
                        <label class="form-label small fw-semibold text-muted">
                            Tanggal Dari
                        </label>

                        <input
                            v-model="filter.date1"
                            type="date"
                            class="form-control"
                            :disabled="loading"
                        />
                    </div>

                    <div class="col-12 col-md-6 col-xl-3">
                        <label class="form-label small fw-semibold text-muted">
                            Tanggal Sampai
                        </label>

                        <input
                            v-model="filter.date2"
                            type="date"
                            class="form-control"
                            :disabled="loading"
                        />
                    </div>
                </div>

                <div class="d-flex gap-2 mt-3">
                    <button
                        type="button"
                        class="btn btn-primary"
                        :disabled="loading"
                        @click="applyFilter"
                    >
                        <span
                            v-if="loading"
                            class="spinner-border spinner-border-sm me-1"
                        ></span>
                        <i v-else class="fa fa-search me-1"></i>
                        Cari
                    </button>

                    <button
                        type="button"
                        class="btn btn-outline-secondary"
                        :disabled="loading"
                        @click="resetFilter"
                    >
                        <i class="fa fa-refresh me-1"></i>
                        Reset
                    </button>
                </div>
            </div>
        </div>

        <div class="card border-0 shadow-sm">
            <div class="card-header bg-white">
                <div
                    class="d-flex flex-wrap align-items-center justify-content-between gap-2"
                >
                    <div class="fw-semibold">
                        <i class="fa fa-folder-open text-success me-1"></i>
                        Daftar File Status Masuk
                    </div>

                    <div class="d-flex align-items-center gap-2">
                        <span class="small text-muted">Tampilkan</span>

                        <select
                            v-model.number="perPage"
                            class="form-select form-select-sm per-page"
                            :disabled="loading"
                            @change="loadData(1)"
                        >
                            <option :value="10">10</option>
                            <option :value="25">25</option>
                            <option :value="50">50</option>
                            <option :value="100">100</option>
                        </select>

                        <span class="small text-muted">data</span>
                    </div>
                </div>
            </div>

            <div class="card-body p-0 position-relative">
                <div v-if="loading" class="loading-overlay">
                    <div class="text-center">
                        <div class="spinner-border text-primary"></div>
                        <div class="mt-2 text-muted">Memuat data...</div>
                    </div>
                </div>

                <div class="table-responsive">
                    <table
                        class="table table-bordered table-hover align-middle mb-0"
                    >
                        <thead class="table-light">
                            <tr>
                                <th>No</th>
                                <th>No.Reg</th>
                                <th>RM</th>
                                <th>Nama Pasien</th>
                                <th>Tgl Reg</th>
                                <th>Jam Reg</th>
                                <th>Tgl Masuk</th>
                                <th>Jam Masuk</th>
                                <th>Keterangan</th>
                                <th>Poli</th>
                                <th>Dokter</th>
                                <th>Tujuan</th>
                                <th>Bayar</th>
                                <th>User</th>
                                <th>Action</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr
                                v-for="(item, index) in rows"
                                :key="item.regno + '-' + index"
                                :class="{
                                    'table-danger': !item.status,
                                }"
                            >
                                <td>{{ rowNumber(index) }}</td>
                                <td>{{ show(item.regno) }}</td>
                                <td>{{ show(item.medrec) }}</td>
                                <td>{{ show(item.firstname) }}</td>
                                <td>{{ formatDate(item.regdate) }}</td>
                                <td>{{ formatTime(item.regtime) }}</td>
                                <td>{{ formatDate(item.tanggalmasuk) }}</td>
                                <td>{{ formatTime(item.jammasuk) }}</td>
                                <td>{{ show(item.status) }}</td>
                                <td>{{ show(item.nmpoli) }}</td>
                                <td>{{ show(item.nmdoc) }}</td>
                                <td>{{ show(item.nmtuju) }}</td>
                                <td>{{ show(item.nmcbayar) }}</td>
                                <td>{{ show(item.validuser) }}</td>
                                <td class="text-center">
                                    <button
                                        type="button"
                                        class="btn btn-primary btn-sm"
                                        @click="openEdit(item)"
                                    >
                                        <i class="fa fa-edit"></i>
                                    </button>
                                </td>
                            </tr>

                            <tr v-if="!loading && rows.length === 0">
                                <td
                                    colspan="15"
                                    class="text-center text-muted py-4"
                                >
                                    Data tidak ditemukan.
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="card-footer bg-white">
                <div
                    class="d-flex justify-content-between align-items-center flex-wrap gap-2"
                >
                    <small class="text-muted">
                        Menampilkan {{ pagination.from || 0 }} -
                        {{ pagination.to || 0 }} dari
                        {{ pagination.total || 0 }} data
                    </small>

                    <div class="btn-group">
                        <button
                            class="btn btn-sm btn-outline-secondary"
                            :disabled="pagination.current_page <= 1 || loading"
                            @click="loadData(pagination.current_page - 1)"
                        >
                            <i class="fa fa-chevron-left"></i>
                        </button>

                        <button class="btn btn-sm btn-light" disabled>
                            {{ pagination.current_page }}
                            /
                            {{ pagination.last_page }}
                        </button>

                        <button
                            class="btn btn-sm btn-outline-secondary"
                            :disabled="
                                pagination.current_page >=
                                    pagination.last_page || loading
                            "
                            @click="loadData(pagination.current_page + 1)"
                        >
                            <i class="fa fa-chevron-right"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="modal" class="custom-modal" @click.self="closeModal">
            <div class="custom-modal-dialog">
                <div class="card border-0 shadow-lg">
                    <div class="card-header bg-success text-white">
                        <div
                            class="d-flex justify-content-between align-items-center"
                        >
                            <strong>File Status Masuk</strong>

                            <button
                                type="button"
                                class="btn-close btn-close-white"
                                @click="closeModal"
                            ></button>
                        </div>
                    </div>

                    <div class="card-body">
                        <div class="row g-3">
                            <div class="col-md-6">
                                <label class="form-label">No. Registrasi</label>
                                <input
                                    v-model="form.noRegno"
                                    class="form-control"
                                    readonly
                                />
                            </div>

                            <div class="col-md-6">
                                <label class="form-label">No. RM</label>
                                <input
                                    v-model="form.noMedrec"
                                    class="form-control"
                                    readonly
                                />
                            </div>

                            <div class="col-12">
                                <label class="form-label">Nama Pasien</label>
                                <input
                                    v-model="form.nama_pasien"
                                    class="form-control"
                                    readonly
                                />
                            </div>

                            <div class="col-md-6">
                                <label class="form-label">Tanggal</label>
                                <input
                                    v-model="form.no_tanggal"
                                    type="date"
                                    class="form-control"
                                    readonly
                                />
                            </div>

                            <div class="col-md-6">
                                <label class="form-label">Jam</label>
                                <input
                                    v-model="form.no_jam"
                                    class="form-control"
                                    readonly
                                />
                            </div>

                            <div class="col-12">
                                <label class="form-label fw-semibold">
                                    Status
                                </label>

                                <div class="form-check mb-2">
                                    <input
                                        id="masuk-status-1"
                                        v-model="form.Status"
                                        type="radio"
                                        value="1"
                                        class="form-check-input"
                                    />
                                    <label
                                        for="masuk-status-1"
                                        class="form-check-label"
                                    >
                                        Status Kembali
                                    </label>
                                </div>

                                <div class="form-check">
                                    <input
                                        id="masuk-status-2"
                                        v-model="form.Status"
                                        type="radio"
                                        value="2"
                                        class="form-check-input"
                                    />
                                    <label
                                        for="masuk-status-2"
                                        class="form-check-label"
                                    >
                                        Mutasi Rawat Inap
                                    </label>
                                </div>
                            </div>

                            <div class="col-12">
                                <label class="form-label">
                                    Nama Peminjam / Penjamin
                                </label>
                                <input
                                    v-model="form.NmPenjamin"
                                    class="form-control"
                                />
                            </div>

                            <div class="col-12">
                                <label class="form-label">Bagian</label>
                                <input
                                    v-model="form.noBagian"
                                    class="form-control"
                                />
                            </div>

                            <div class="col-12">
                                <label class="form-label">Keterangan</label>
                                <textarea
                                    v-model="form.keterangan"
                                    class="form-control"
                                    rows="3"
                                ></textarea>
                            </div>
                        </div>
                    </div>

                    <div class="card-footer bg-white text-end">
                        <button
                            class="btn btn-secondary me-2"
                            :disabled="saving"
                            @click="closeModal"
                        >
                            Tutup
                        </button>

                        <button
                            class="btn btn-success"
                            :disabled="saving"
                            @click="save"
                        >
                            <span
                                v-if="saving"
                                class="spinner-border spinner-border-sm me-1"
                            ></span>
                            <i v-else class="fa fa-save me-1"></i>
                            {{ saving ? "Menyimpan..." : "Simpan" }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "FileStatusMasuk",

    data() {
        const today = this.today();

        return {
            loading: false,
            saving: false,
            modal: false,
            rows: [],
            perPage: 25,
            filter: {
                Regno: "",
                Medrec: "",
                Firstname: "",
                date1: today,
                date2: today,
            },
            pagination: {
                current_page: 1,
                last_page: 1,
                per_page: 25,
                from: null,
                to: null,
                total: 0,
            },
            form: {
                noRegno: "",
                noMedrec: "",
                nama_pasien: "",
                no_tanggal: "",
                no_jam: "",
                Status: "1",
                NmPenjamin: "",
                noBagian: "",
                keterangan: "",
            },
        };
    },

    mounted() {
        this.loadData();
    },

    methods: {
        today() {
            const date = new Date();
            const offset = date.getTimezoneOffset();
            return new Date(date.getTime() - offset * 60000)
                .toISOString()
                .substring(0, 10);
        },

        async loadData(page = 1) {
            this.loading = true;

            try {
                const response = await this.axios.get(
                    "/api/monitoring-file-status/file-status-masuk",
                    {
                        params: {
                            ...this.filter,
                            page,
                            per_page: this.perPage,
                        },
                    }
                );

                if (response.data.status !== "success") {
                    throw new Error(response.data.message);
                }

                this.rows = response.data.list.data || [];
                this.pagination = response.data.list;
            } catch (error) {
                this.rows = [];

                this.showError(
                    error.response?.data?.message ||
                        error.message ||
                        "Data gagal dimuat."
                );
            } finally {
                this.loading = false;
            }
        },

        applyFilter() {
            if (
                this.filter.date1 &&
                this.filter.date2 &&
                this.filter.date2 < this.filter.date1
            ) {
                this.showError(
                    "Tanggal sampai tidak boleh lebih kecil dari tanggal mulai."
                );
                return;
            }

            this.loadData(1);
        },

        resetFilter() {
            const today = this.today();

            this.filter = {
                Regno: "",
                Medrec: "",
                Firstname: "",
                date1: today,
                date2: today,
            };

            this.loadData(1);
        },

        openEdit(item) {
            this.form = {
                noRegno: item.regno || "",
                noMedrec: item.medrec || "",
                nama_pasien: item.firstname || "",
                no_tanggal: this.dateInput(item.regdate),
                no_jam: this.formatTime(item.regtime),
                Status: item.nstatus ? String(item.nstatus) : "1",
                NmPenjamin: item.namapeminjam || "",
                noBagian: item.bagian || "",
                keterangan: item.keterangan || "",
            };

            this.modal = true;
        },

        closeModal() {
            if (!this.saving) {
                this.modal = false;
            }
        },

        async save() {
            this.saving = true;

            try {
                const response = await this.axios.post(
                    "/api/monitoring-file-status/file-status-masuk",
                    {
                        noRegno: this.form.noRegno,
                        Status: this.form.Status,
                        NmPenjamin: this.form.NmPenjamin,
                        noBagian: this.form.noBagian,
                        keterangan: this.form.keterangan,
                    }
                );

                if (response.data.status !== "success") {
                    throw new Error(response.data.message);
                }

                this.modal = false;

                await this.$swal.fire({
                    title: "Berhasil",
                    text: response.data.message,
                    icon: "success",
                });

                await this.loadData(this.pagination.current_page);
            } catch (error) {
                this.showError(
                    error.response?.data?.message ||
                        error.message ||
                        "Data gagal disimpan."
                );
            } finally {
                this.saving = false;
            }
        },

        printPdf() {
            const query = new URLSearchParams(this.filter);

            window.open(
                `/api/monitoring-file-status/file-status-masuk/pdf?${query.toString()}`,
                "_blank"
            );
        },

        rowNumber(index) {
            return (
                (this.pagination.current_page - 1) * this.pagination.per_page +
                index +
                1
            );
        },

        show(value) {
            return value === null || value === undefined || value === ""
                ? "-"
                : value;
        },

        dateInput(value) {
            if (!value) return "";
            return String(value).substring(0, 10);
        },

        formatDate(value) {
            if (!value) return "-";

            const text = String(value);
            const match = text.match(/^(\d{4})-(\d{2})-(\d{2})/);

            return match ? `${match[3]}/${match[2]}/${match[1]}` : text;
        },

        formatTime(value) {
            if (!value) return "-";

            const match = String(value).match(/(\d{2}):(\d{2})(?::(\d{2}))?/);

            return match ? `${match[1]}:${match[2]}` : String(value);
        },

        showError(message) {
            this.$swal.fire({
                title: "Error",
                text: message,
                icon: "error",
            });
        },
    },
};
</script>

<style scoped>
.per-page {
    width: 80px;
}

.table {
    font-size: 13px;
    white-space: nowrap;
}

.loading-overlay {
    position: absolute;
    inset: 0;
    z-index: 20;
    min-height: 180px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.78);
}

.custom-modal {
    position: fixed;
    inset: 0;
    z-index: 1055;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    overflow-y: auto;
    background: rgba(0, 0, 0, 0.5);
}

.custom-modal-dialog {
    width: 100%;
    max-width: 700px;
}
</style>
